import { BaseGetInputModel } from "../../../../models/http/InputModel/BaseGetInputModel"

export class MypageUserGetInputModel extends BaseGetInputModel {
  constructor() {
    super()
  }
}
